import PinterestIconDark from 'assets/images/icons/dark - pinterest.svg?react';
import PinterestIconSimpleFiligree from 'assets/images/icons/simple filigree - pinterest.svg?react';
import PinterestIconSpringVibes from 'assets/images/icons/spring - pinterest.svg?react';
import PinterestIconVickyBaumannBoho from 'assets/images/icons/vicky boho - pinterest.svg?react';
import PinterestIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - pinterest.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyPinterestIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={PinterestIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={PinterestIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={PinterestIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={PinterestIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={PinterestIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={PinterestIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={PinterestIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={PinterestIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={PinterestIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={PinterestIconSimpleFiligree} {...props} />
  })();

export const PinterestIcon = (props: IIconProps) => (
  <SetIcon slug="pinterest" fallback={LegacyPinterestIcon} {...props} />
);
